interface Props { sessionId: string }

export function CalendarButton({ sessionId }: Props) {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  const href = `${supabaseUrl}/functions/v1/session-ics?id=${sessionId}`;
  return (
    <a href={href} className="btn-secondary w-full justify-center" target="_blank" rel="noopener noreferrer">
      📅 Додати в календар
    </a>
  );
}
